module.exports = __webpack_public_path__ + "static/1-016-eeeb5d795ebe558582ab23992bc388bd.png";